import DownloadIconDark from 'assets/images/icons/dark - download.svg?react';
import DownloadIconSimpleFiligree from 'assets/images/icons/simple filigree - download.svg?react';
import DownloadIconSpringVibes from 'assets/images/icons/spring - download.svg?react';
import DownloadIconVickyBaumannBoho from 'assets/images/icons/vicky boho - download.svg?react';
import DownloadIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - download.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyDownloadIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={DownloadIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={DownloadIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={DownloadIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={DownloadIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={DownloadIconSimpleFiligree} {...props} />
  })();

export const DownloadIcon = (props: IIconProps) => (
  <SetIcon slug="download" fallback={LegacyDownloadIcon} {...props} />
);
